module.exports = __webpack_public_path__ + "img/music-work-icon4.29994a8e.png";